// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tG-z","twoColumnImage":"uG-z"};